import { useEffect, useState, useRef } from "react";
import { Button, Col, Dropdown, Menu, Popconfirm, Typography, Tag, message } from "antd";
import { ReactComponent as DeleteSubIcon } from "../../../../assets/icons/DeleteSubOrder.svg";
import { ReactComponent as AddIcon } from "../../../../assets/icons/AddIcon.svg";
import { ReactComponent as DotIcon } from "../../../../assets/icons/DotIcon.svg";
import { ReactComponent as Document } from "../../../../assets/icons/viewDocument.svg";
import { ReactComponent as UploadIconSvg } from "../../../../assets/seller/icons/upload-2.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/seller/icons/download.svg";
import CreateOrderDrawer from "../../../../components/Drawer/CreateOrderDrawer/CreateOrderDrawer";
import * as XLSX from "xlsx";
const { Text } = Typography;
const TableHeader = ({
  handleAddRow,
  tableIndex,
  handleDeleteTable,
  sellerList,
  getAllVendors,
  selectedSeller,
  setSelectedSeller,
  editCondition,
  initialValue,
  bmpPrice,
  getProductApi,
  getProductListData,
  getProductModalApi,
  handleBulkUpload,
}) => {
  const bmpId = localStorage.getItem("bmp_id");
  const bmpName = localStorage.getItem("bmp_name");
  const [drawerVisible, setDrawerVisible] = useState(false);
  const fileInputRef = useRef(null);

  const handleOpenRfqModal = () => {
    setDrawerVisible(true);
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleDownloadTemplate = () => {
    // Download the static template file from the public folder
    const link = document.createElement('a');
    link.href = process.env.PUBLIC_URL
      ? process.env.PUBLIC_URL + '/product-upload-template.xlsx'
      : '/product-upload-template.xlsx';
    link.download = 'product-upload-template.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    message.success("Template downloaded successfully!");
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    const validTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!validTypes.includes(file.type)) {
      message.error("Please upload a valid Excel file (.xls or .xlsx)");
      return;
    }

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      if (jsonData.length === 0) {
        message.error("The Excel file is empty");
        return;
      }

      // Validate required columns
      const requiredColumns = ["Product Name", "Quantity"];
      const firstRow = jsonData[0];
      const missingColumns = requiredColumns.filter(col => !(col in firstRow));
      
      if (missingColumns.length > 0) {
        message.warning(`Excel should contain at least: ${requiredColumns.join(", ")}. Missing columns will use default values.`);
      }

      // Pass the parsed data to the parent component
      handleBulkUpload(jsonData, tableIndex);
      // message.success(`Successfully imported ${jsonData.length} items`);
      
      // Reset the file input
      e.target.value = "";
    } catch (error) {
      console.error("Error reading Excel file:", error);
      message.error("Failed to read Excel file. Please check the file format.");
    }
  };

  useEffect(() => {
    if (editCondition && sellerList?.length > 0) {
      const list = initialValue?.map((item, index) => {
        const sellerData = sellerList
          ?.map((element, i) => {
            if (element.bmp_id === item) {
              const editObj = {
                ...element,
                label: element.vendor_name,
                vendor_name: element.vendor_name,
                key: element.bmp_id,
                bmp_id: element.bmp_id,
              };
              return editObj;
            }
            return null;
          })
          .filter(Boolean);
        return sellerData;
      });
      let finalList = [];
      list?.map((item) => {
        item.map((element) => {
          return finalList.push(element);
        });
        return null;
      });
      if (!(initialValue?.length <= selectedSeller?.length)) {
        setSelectedSeller(finalList || selectedSeller);
      }
    } else {
      let finalList = [];
      if (bmpId && bmpName) {
        finalList.push({
          bmp_id: bmpId,
          label: bmpName,
          vendor_name: bmpName,
          key: bmpId,
        });
      }
      if (!(initialValue?.length <= selectedSeller?.length)) {
        setSelectedSeller(finalList || selectedSeller);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editCondition, sellerList]);

  const subOrderMenu = (
    <Menu>
      <Popconfirm
        title={
          <Text
            style={{
              display: "block",
            }}
          >
            Are you sure ?
          </Text>
        }
        style={{ width: "150px" }}
        trigger="click"
        onConfirm={() => handleDeleteTable(tableIndex, bmpPrice[tableIndex])}
      >
        <Menu.Item
          key="1"
          // onClick={() => handleDeleteTable(tableIndex)}
        >
          {" "}
          <Col
            style={{
              color: "#bf2600",
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
            // onClick={handleOpenPopover}
          >
            <DeleteSubIcon />
            <Text
              style={{
                color: "#bf2600",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              Delete suborder
            </Text>
          </Col>
        </Menu.Item>
      </Popconfirm>
    </Menu>
  );

  return (
    <>
      <Col
        key={tableIndex}
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Col
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "16px",
          }}
        >
          <Tag
            style={{
              width: "160px",
              height: "33px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              fontWeight: 500,
              fontSize: "14px",
              cursor: "Pointer",
              borderRadius: "12px",
            }}
            className={"btn-viewcatalogue"}
            onClick={handleOpenRfqModal}
          >
            <Document />
            View catalogue
          </Tag>
          <Button
            onClick={() => handleAddRow(tableIndex)}
            type="primary"
            style={{
              width: "140px",
              fontWeight: 500,
              height: "33px",
              borderRadius: "12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            icon={<AddIcon style={{ alignItems: "center" }} />}
          >
            Add item
          </Button>
          <Button
            onClick={handleUploadClick}
            type="default"
            style={{
              width: "140px",
              fontWeight: 500,
              height: "33px",
              borderRadius: "12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1px solid #d9d9d9",
            }}
            icon={<UploadIconSvg style={{ alignItems: "center", width: 16, height: 16 }} />}
          >
            Upload
          </Button>
          <Button
            onClick={handleDownloadTemplate}
            type="default"
            style={{
              width: "180px",
              fontWeight: 500,
              height: "33px",
              borderRadius: "12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
          
             
            }}
            icon={<DownloadIcon style={{ alignItems: "center" , width: 16, height: 16}} />}
          >
            Download Template
          </Button>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            accept=".xlsx,.xls"
            style={{ display: "none" }}
          />
          {tableIndex !== 0 && (
            <Dropdown overlay={subOrderMenu} trigger={["click"]}>
              <Col
                style={{
                  height: "33px",
                  width: "33px",
                  borderRadius: "8px",
                  border: "solid 1px #eaeaea",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <DotIcon />
              </Col>
            </Dropdown>
          )}
        </Col>
      </Col>
      <CreateOrderDrawer
        drawerVisible={drawerVisible}
        setDrawerVisible={setDrawerVisible}
        data={selectedSeller[tableIndex]}
        handleAddRow={handleAddRow}
        tableIndex={tableIndex}
        getProductApi={getProductApi}
        getProductListData={getProductListData}
        getProductModalApi={getProductModalApi}
      />
    </>
  );
};

export default TableHeader;
